import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from "@angular/material/dialog";
import {Title} from "@angular/platform-browser";
import {faRotateLeft, faTrash} from "@fortawesome/free-solid-svg-icons";
import {AssessmentService} from "../../../services/assessment.service";
import {DialogService} from "../../../services/dialog.service";
import {firstValueFrom} from "rxjs";
import {ReportService} from "../../../services/report.service";

export enum FireDeleteType {
  SIMPLE,
  COMPLEX,
  UNDO_MERGE,
  REPORT
}

@Component({
    selector: 'app-delete-fire',
    templateUrl: './delete-fire.component.html',
    styleUrl: './delete-fire.component.scss',
    standalone: false
})
export class DeleteFireComponent implements OnInit {
  protected readonly faRotateLeft = faRotateLeft;
  protected readonly faTrash = faTrash;
  protected readonly FireDeleteType = FireDeleteType

  title!: string;
  fireDeleteType!: FireDeleteType;
  fireName!: string;
  reportName!: string;

  constructor(
    public dialogRef: MatDialogRef<DeleteFireComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public readonly dialog: MatDialog,
    private readonly titleService: Title,
    private readonly assessmentService: AssessmentService,
    private readonly dialogService: DialogService,
    private readonly reportService: ReportService,
  ) {
    this.titleService.setTitle("BAER - Delete Fire")
    dialogRef.disableClose = true;
  }

  ngOnInit(): void {
    const assessment = this.data.fireRecord;
    this.fireName = assessment.baer_name;
    if (['NEW', 'GIS'].includes(assessment.source)) {
      this.title = 'Delete Fire';
      if ([0, 1, 2, 13].includes(assessment.assessment_status_id)) {
        this.fireDeleteType = FireDeleteType.SIMPLE;
      } else if ([3, 12].includes(assessment.assessment_status_id)) {
        this.fireDeleteType = FireDeleteType.COMPLEX;
      }
    } else if ([1,3].includes(assessment.assessment_status_id) && ['MERGE'].includes(assessment.source)) {
      this.title = 'Undo Merge';
      this.fireDeleteType = FireDeleteType.UNDO_MERGE;
    }
    if (this.data.report) {
      this.fireDeleteType = FireDeleteType.REPORT;
      this.title = 'Delete Report';
      this.reportName = `${this.fireName} (${this.data.report.report_num})`;
    }
  }

  async onDelete() {
    this.dialogService.openSpinner();
    if (this.fireDeleteType !== FireDeleteType.REPORT) {
      await firstValueFrom(this.assessmentService.deleteAssessmentAndReportIfPresent([this.data.fireRecord.assessment_id]));
    } else {
      await firstValueFrom(this.reportService.deleteReport([this.data.report.report_id]));
    }
    this.dialogService.closeSpinner();
    this.dialogRef.close(true);
  }

  async onUndoMerge() {
    this.dialogService.openSpinner();
    await firstValueFrom(this.assessmentService.undoMergeAssessments({assessment_id_list: [this.data.fireRecord.assessment_id]}));
    this.dialogService.closeSpinner();
    this.dialogRef.close(true);
  }
}
